import type { VFC } from 'react';
import { memo, useCallback } from 'react';

import { addUFOCustomMark } from '@atlaskit/react-ufo/custom-mark';

import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

import { ActionTiming, usePerformanceAction } from '../usePerformanceAction.tsx';
import { PAGE_SEGMENT_MARK_PREFIX_START } from '../metric-keys/index.ts';
import type { PageSegmentLoadStartProps } from '../Bm3PageSegmentLoadStart.tsx';

const noop = () => {};

const UFOSegmentLoadStartComponent: VFC<PageSegmentLoadStartProps> = memo(
	({ metric, onComplete = noop, timing = ActionTiming.RENDER_BODY }) => {
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		if (process.env.REACT_SSR) {
			SSRMeasures.markMeasureStart(`ssr-app/render/${metric.key}`);
		}

		const handleSegmentLoadStart = useCallback(() => {
			if (metric) {
				addUFOCustomMark(`${PAGE_SEGMENT_MARK_PREFIX_START}:${metric.key}`);
				onComplete();
			}
		}, [metric, onComplete]);

		usePerformanceAction(handleSegmentLoadStart, timing);
		return null;
	},
);

export const UFOSegmentLoadStart = withTransparentErrorBoundary({
	attribution: Attribution.BACKBONE,
})(UFOSegmentLoadStartComponent);
